export default function transformOptions(options) {
  return options.map((option) => {
    const transformed = {
      label: option?.name || option?.tag,
      value: option?.id || option?.name || option?.tag,
    };

    if (Object.prototype.hasOwnProperty.call(option, "active")) {
      transformed.active = option.active;
    }

    return transformed;
  });
}
